import React, { useState, useEffect } from "react";
import { X, CheckCircle, AlertCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function UploadPlant() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(true); // Show modal on entry

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) {
      alert("Please select file");
      return;
    }
    alert("करारपत्रक यशस्वीरित्या अपलोड झाले!");
  };

  return (
    <div className="pb-8">
      
      {/* Page Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-2 max-w-6xl mx-auto">
        <div>
          <h1 className="text-2xl font-bold text-slate-800 uppercase">अपलोड (प्लॅन्ट) PLANT करारपत्रक</h1>
        </div>
        <nav className="text-sm text-slate-400 bg-white px-4 py-2 rounded-full shadow-sm border">
          सांगली जिल्हा परिषद / <span className="text-slate-700 font-medium">करारपत्रक अपलोड</span>
        </nav>
      </div>

      <div className="max-w-4xl mx-auto">
        {/* Main Card */}
        <div className="bg-white rounded-xl shadow-md border border-slate-200 p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
              <div className="flex items-center">
                <AlertCircle className="text-blue-500 mr-3" size={20} />
                <p className="text-sm text-blue-700 font-medium">
                  कृपया तुमचा (प्लॅन्ट) करारपत्रक दस्तऐवज पीडीएफ किंवा इमेज फॉरमॅटमध्ये अपलोड करा.
                </p>
              </div>
            </div>

            <div>
              <label className="block text-sm font-bold text-slate-700 mb-2 uppercase">
                अपलोड प्लॅन्ट करारपत्रक <span className="text-red-500">*</span>
              </label>
              <div className="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-slate-300 border-dashed rounded-lg hover:border-blue-400 transition-colors bg-slate-50/50">
                <div className="space-y-1 text-center font-inter">
                  <svg className="mx-auto h-12 w-12 text-slate-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <div className="flex text-sm text-slate-600">
                    <label htmlFor="file-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500">
                      <span>फाईल निवडा</span>
                      <input id="file-upload" name="file-upload" type="file" className="sr-only" onChange={handleFileChange} />
                    </label>
                    <p className="pl-1">किंवा ड्रॅग करून सोडा</p>
                  </div>
                  <p className="text-xs text-slate-500">PDF, PNG, JPG (कमाल. 5MB)</p>
                  {file && <p className="mt-2 text-sm font-bold text-green-600">निवडलेली फाईल: {file.name}</p>}
                </div>
              </div>
            </div>

            <div className="flex justify-end pt-4 border-t">
              <button
                type="submit"
                className="px-8 py-3 bg-blue-600 text-white rounded-lg font-bold shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all hover:scale-[1.02] active:scale-[0.98]"
              >
                अपलोड करा (Submit)
              </button>
            </div>

          </form>
        </div>
      </div>

      {/* Yes/No Popup Modal */}
      {showModal && (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full overflow-hidden animate-in fade-in zoom-in duration-300">
            {/* Modal Header */}
            <div className="bg-slate-50 px-6 py-4 border-b flex justify-between items-center">
              <h3 className="text-lg font-bold text-slate-800">कामवाटपातील कामे (पासबुक)</h3>
              <button onClick={() => setShowModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors">
                <X size={20} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-8 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <AlertCircle className="text-blue-600" size={32} />
              </div>
              <p className="text-xl text-slate-700 leading-relaxed font-medium">
                या पूर्वी कामवाटपामध्ये काम मिळाले आहेत का? असेल तर पासबुक भरून घ्यावे.
              </p>
            </div>

            {/* Modal Footer */}
            <div className="bg-slate-50 px-6 py-4 flex gap-3 justify-end border-t">
              <button
                onClick={() => setShowModal(false)}
                className="px-6 py-2.5 rounded-lg border border-slate-300 font-bold text-slate-600 hover:bg-slate-100 transition-all active:scale-95"
              >
                नाही (Stay Here)
              </button>
              <button
                onClick={() => {
                  setShowModal(false);
                  navigate("/passbook-update");
                }}
                className="px-8 py-2.5 rounded-lg bg-blue-600 font-bold text-white shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all active:scale-95 flex items-center gap-2"
              >
                होय (Go to Passbook)
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}